__turbopack_context__.v({
  "className": "sohnemono_ca99fedf-module__Cwxn8W__className",
});
